"use client";

import { useEffect } from "react";
import { useCartStore } from "@/lib/store/cartStore";

/**
 * CartSessionInitializer
 * 
 * Initializes the cart session for guest users on first load.
 * This component should be mounted once at the app root level.
 * 
 * Behavior:
 * - Generates a session ID ("guest-" + UUID v4) if one doesn't exist
 * - Session ID is persisted in localStorage via Zustand persist middleware
 * - Session ID is used to track guest user carts before authentication
 * - Session ID is cleared after merging guest cart with authenticated user
 */
export function CartSessionInitializer() {
  const initializeSession = useCartStore((state) => state.initializeSession);

  useEffect(() => {
    // Initialize session on mount
    initializeSession();
  }, [initializeSession]);

  // This component doesn't render anything
  return null;
}
